export function setupGlobDirectives() {}
